import { Controller } from "@hotwired/stimulus"

// Shows an info icon's tooltip on hover/focus and pins it open on click, so it
// also works on touch and stays up while it's being read. A click anywhere else
// unpins it.
//
// The tooltip is placed with position:fixed against the trigger's box so it
// escapes an ancestor's overflow clipping (e.g. the scrollable invoice items
// table) instead of being cut off — the same trick as floating_menu_controller.
export default class extends Controller {
  static targets = ["tooltip", "trigger"]

  connect() {
    this.pinned = false
    this.reposition = this.reposition.bind(this)
  }

  disconnect() {
    this.stopTracking()
  }

  dismiss(event) {
    if (this.element.contains(event.target)) return
    this.pinned = false
    this.close()
  }

  hide() {
    if (!this.pinned) this.close()
  }

  show() {
    this.open()
  }

  toggle() {
    this.pinned = !this.pinned
    this.pinned ? this.open() : this.close()
  }

  open() {
    this.tooltipTarget.classList.remove("hidden")
    this.reposition()
    // Capture phase so scrolling inside any container (the table) is caught.
    window.addEventListener("scroll", this.reposition, true)
    window.addEventListener("resize", this.reposition)
  }

  close() {
    this.tooltipTarget.classList.add("hidden")
    this.stopTracking()
  }

  reposition() {
    Object.assign(this.tooltipTarget.style, {
      left: "0px",
      margin: "0",
      position: "fixed",
      top: "0px",
    })

    const rect = this.triggerTarget.getBoundingClientRect()
    const { offsetHeight: height, offsetWidth: width } = this.tooltipTarget
    // Below the icon, unless that would run off the bottom of the viewport.
    const below = rect.bottom + 6
    const fitsBelow = below + height <= window.innerHeight - 8

    Object.assign(this.tooltipTarget.style, {
      left: `${Math.min(Math.max(8, rect.left), window.innerWidth - width - 8)}px`,
      top: `${fitsBelow ? below : Math.max(8, rect.top - height - 6)}px`,
    })
  }

  stopTracking() {
    window.removeEventListener("scroll", this.reposition, true)
    window.removeEventListener("resize", this.reposition)
  }
}
